"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRolesFromUserJWT = getUserRolesFromUserJWT;
exports.hasRole = hasRole;
exports.isRegionalManager = isRegionalManager;
exports.getRegionalManagerCountryIds = getRegionalManagerCountryIds;
exports.restrictRegionalManagerOptions = restrictRegionalManagerOptions;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
/**
 * Authorization service to be used only in the /legacy scope
 * for authorizing in /api the access-control/authorization-service.ts should be used instead
 */
function getUserRolesFromUserJWT(userJWT) {
    const roles = userJWT?.roles ?? [];
    const roleDetails = userJWT?.roleDetails ?? [];
    return {
        roles,
        roleDetails,
    };
}
function hasRole(userJWT, role) {
    const { roles } = getUserRolesFromUserJWT(userJWT);
    return roles.includes(role);
}
function isRegionalManager(userJWT) {
    return hasRole(userJWT, legacy_enums_1.RolesEnum.RegionalManager) || hasRole(userJWT, legacy_enums_1.RolesEnum.SeniorRegionalManager);
}
function getRegionalManagerCountryIds(userJWT) {
    if (!isRegionalManager(userJWT)) {
        return [];
    }
    const { roles, roleDetails } = getUserRolesFromUserJWT(userJWT);
    const rmRole = roles.includes(legacy_enums_1.RolesEnum.SeniorRegionalManager) ? legacy_enums_1.RolesEnum.SeniorRegionalManager : legacy_enums_1.RolesEnum.RegionalManager;
    return roleDetails?.[rmRole]?.countryIds || [];
}
function restrictRegionalManagerOptions(userJWT, options) {
    if (isRegionalManager(userJWT)) {
        const rmCountryIds = getRegionalManagerCountryIds(userJWT);
        options.countryIds = (0, utils_1.optionalIntersection)(options.countryIds, rmCountryIds);
    }
    return options;
}
//# sourceMappingURL=role-utils.js.map